//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionFallback(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 2H19V12.0122H17V4H7V8.9102L10.0002 6.00004V8.62004L6.00017 12.48L2 8.62V6L5 8.90991V2Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M2 14H10V22H2V14ZM4 16V20H8V16H4Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M14 14H22V22H14V14ZM16 16V20H20V16H16Z" fill="currentColor" /></svg>;
}
export default IconActionFallback;